import { bytesToHex, hexToBytes } from "@noble/hashes/utils";
import { secp256k1 } from "@noble/curves/secp256k1";
export default function getUncompressedPublicKey(publicKey) {
    const publicKeyBytes = hexToBytes(publicKey);
    const uncompressedPublicKeyBytes = secp256k1.ProjectivePoint.fromHex(publicKeyBytes).toRawBytes(false);
    return bytesToHex(uncompressedPublicKeyBytes);
}
//# sourceMappingURL=getUncompressedPublicKey.js.map